module.exports = __webpack_public_path__ + "img/expovina_01(1).b6b7da27.jpg";